import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context'
import { useMagasinStore } from '@/store/magasin'
import { useGtm } from '@gtm-support/vue-gtm';
import { useRoute } from 'vue-router'

export const useErrorPagesTracking = (context) => {
  const gtm = useGtm();
  const route = useRoute()
  const contextStore = useContextStore();
  const magasinStore = useMagasinStore();

  const { layout: layoutType } = storeToRefs(contextStore);
  const { id: magasinId, name: magasinName } = storeToRefs(magasinStore);

  const trackError = (errorCode) => {
    const pushObject = {
      environnement: process.env.NODE_ENV === 'development' ? 'development' : 'production',
      magasinId: magasinId.value,
      magasinNom: magasinName.value,
      pageLocation: route.path,
      pageType: errorCode === 404 ? 'erreur404' : errorCode === 401 ? 'login' : 'maintenance',
      sitetype: layoutType.value === LayoutTypes.default ? 'd' : 'm',
      event: 'dataLayerReady'
    }
    try {
      gtm.trackEvent(pushObject);
    } catch {
      console.log("ERROR! something went wrong (error page)")
    }
  }

  return { trackError }
}